import * as Yup from "yup";

const ValidationSchema = Yup.object().shape({
  FullName: Yup.string().required("Bu alanın doldurulması zorunludur."),
  BirthDate: Yup.number().required("Bu alanın doldurulması zorunludur."),
  NationalIdNumber: Yup.string()
    .matches(/^((?!(0))[0-9]{11})$/, "Lütfen geçerli bir T.C Kimlik numarası giriniz.")
    .required("Bu alanın doldurulması zorunludur."),
  EducationLevel: Yup.string().required("Bu alanın doldurulması zorunludur."),
  Phone: Yup.string()
    .matches(
      /^\+90 \(5?([0-9]{2})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
      "Lütfen geçerli bir cep telefonu numarası giriniz."
    )
    .required("Bu alanın doldurulması zorunludur."),
  Email: Yup.string()
    .email("Lütfen geçerli bir e-posta adresi giriniz.")
    .required("Bu alanın doldurulması zorunludur."),
  ResidenceCity: Yup.string().required("Bu alanın doldurulması zorunludur.")
    .min(3, "Lütfen geçerli bir şehir giriniz.")
    .max(20, "Lütfen geçerli bir şehir giriniz.")
    .matches(
      /^[a-zA-ZığüşöçİĞÜŞÖÇ]+$/,
      "Lütfen geçerli bir şehir giriniz."
    ),
  ResidenceAddress: Yup.string().required("Bu alanın doldurulması zorunludur."),
  PreviousCompanyAndTitle: Yup.string().required("Bu alanın doldurulması zorunludur."),
  PreviousPosition: Yup.string().required("Bu alanın doldurulması zorunludur."),
  PreviousExperienceStartDate: Yup.number().required("Bu alanın doldurulması zorunludur."),
  PreviousExperienceEndDate: Yup.number().when("IsCurrentRole", {
    is: false,
    then: Yup.number()
      .min(Yup.ref("PreviousExperienceStartDate"), "Bitiş tarihi başlangıç tarihinden önce olamaz.")
      .required("Bu alanın doldurulması zorunludur.")
  }),
  FranchiseCity: Yup.string().required("Bu alanın doldurulması zorunludur.")
    .min(3, "Lütfen geçerli bir şehir giriniz.")
    .max(20, "Lütfen geçerli bir şehir giriniz.")
    .matches(
      /^[a-zA-ZığüşöçİĞÜŞÖÇ]+$/,
      "Lütfen geçerli bir şehir giriniz."
    ),
  FranchiseDistrict: Yup.string().required("Bu alanın doldurulması zorunludur.")
    .max(20, "Lütfen geçerli bir ilçe giriniz.")
    .matches(
      /^[a-zA-ZığüşöçİĞÜŞÖÇ]+$/,
      "Lütfen geçerli bir ilçe giriniz."
    ),
  FranchiseQuarter: Yup.string().required("Bu alanın doldurulması zorunludur.")
    .max(100, "Semt alanı 100 karakterden fazla olamaz.")
    .matches(
      /^[a-zA-ZığüşöçİĞÜŞÖÇ]+$/,
      "Lütfen geçerli bir semt giriniz."
    ),
  InvestmentAmount: Yup.string().required("Bu alanın doldurulması zorunludur."),
  HasAnotherOccupation: Yup.boolean().required("Bu alanın doldurulması zorunludur."),
  CurrentMonthlyIncome: Yup.string().required("Bu alanın doldurulması zorunludur."),
  ExpectedMonthlyIncome: Yup.string().required("Bu alanın doldurulması zorunludur."),
  Investor: Yup.string().required("Bu alanın doldurulması zorunludur."),
  Manager: Yup.string().required("Bu alanın doldurulması zorunludur."),
  HasManagedCourierOrWarehousePersonnel: Yup.boolean().required(
    "Bu alanın doldurulması zorunludur."
  ),
  WhyBanabi: Yup.string().required("Bu alanın doldurulması zorunludur.")
  .max(500, "Bu alan 500 karakterden fazla olamaz.")
});

export default ValidationSchema;
